import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations'
import getters from './getters'
import actions from './actions'

Vue.use(Vuex)

export interface State {
	loginError: false | string,
	loginMessage: false | string
	preventNavigation: {prevent: boolean, message?: string}
}

const state: State = {
	loginError: false,
	loginMessage: false,
	preventNavigation: {prevent: false}
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})
